export const IPENVendor = "IPENVendor";
export const IframeVendor = "IframeVendor";
export const VerificationVendorType = "VerificationVendorType";
export const FormFreeLenderID = "FormFreeLenderID";
export const attributeOrder = [IPENVendor, IframeVendor, VerificationVendorType, FormFreeLenderID];
export const showIPENVendor = ["eClose-IPEN", "eClose-IPENeNote"];
export const showVerificationVendorType = ["eDisclose", "eSign", "eSignSecondary", "eDiscloseSecondary"];
export const showFormFreeLenderID = ["eDisclose", "eSign", "eSignSecondary", "eDiscloseSecondary"];